import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'counter']
  static values = {
    max: Number,
    template: { type: String, default: '{count} / {max}' },
  }

  connect() {
    this.update()
  }

  update() {
    this.counterTarget.textContent = this.templateValue
      .replace('{count}', this.inputTarget.value.length)
      .replace('{max}', this.maxValue)
  }
}
